module.exports = __webpack_public_path__ + "static/media/clientPhoto9.844d10b2.png";